import { render, staticRenderFns } from "./CatalogMain.vue?vue&type=template&id=49a65684&scoped=true"
import script from "./CatalogMain.vue?vue&type=script&lang=js"
export * from "./CatalogMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a65684",
  null
  
)

export default component.exports